import { Button, Col, Form, Row, Select } from "antd";
import React from "react";
import { v4 as uuidv4 } from "uuid";

function Templates({ templates, setTemplates }) {
  const addTemplate = () => {
    const newTemplate = { id: uuidv4(), template: "" };
    setTemplates([...templates, newTemplate]);
  };

  const removeTemplate = (id) => {
    const updatedTemplates = templates.filter((template) => template.id !== id);
    setTemplates(updatedTemplates);
  };

  const handleChange = (value, name, id) => {
    const updatedTemplates = templates.map((template) => {
      if (template.id === id) {
        return { ...template, [name]: value };
      }
      return template;
    });
    setTemplates(updatedTemplates);
  };

  return (
    <>
      {templates.map((template) => (
        <Row gutter={[8, 0]} key={template.id}>
          <Col span={21}>
            <Form.Item key={template.id}>
              <Select
                value={template.template}
                onChange={(value) =>
                  handleChange(value, "template", template.id)
                }
                options={[{ value: "New Move in Lease Template" }, { value: "Renewal Lease Template" }]}
                showSearch
                placeholder="Choose Template"
              />
            </Form.Item>
          </Col>
          <Col span={2}>
            {templates.length > 1 && (
              <Button
                className="roundSmallButton"
                onClick={() => {
                  removeTemplate(template.id);
                }}
                type="primary"
                shape="circle"
                icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                size={"small"}
              />
            )}
          </Col>
        </Row>
      ))}
      <Button
        className="addPropertyGroupButton"
        type="primary"
        onClick={addTemplate}
        size={"small"}
        icon={<i className="fa-solid fa-circle-plus"></i>}
      >
        Add Another Template
      </Button>
    </>
  );
}

export default Templates;
